import {STATUS_CODES} from 'core/constants';

export const NOT_FOUND_INFO = {
    buttonText: 'К покупкам!',
    description: (
        <>
            Кажется такой страницы нет 🙁
            <br />
            Но у нас еще много вкусного!
        </>
    ),
    href: '/catalog/',
    statusCode: String(STATUS_CODES.NOT_FOUND),
};

export const ERROR_BOUNDARY_INFO = {
    buttonText: 'Обновить страницу',
    description: (
        <>
            Сайт временно недоступен 🙁
            <br />
            Мы уже устраняем неисправность, попробуйте обновить страницу через некоторое время. Приносим извинения за
            доставленные неудобства.
        </>
    ),
};

export const ERROR_PAGE_LINKS = [
    {
        href: '/catalog/vino/filter/main-to-1000/',
        title: 'Вино до 1 000 ₽',
    },
    {
        href: '/catalog/vino/filter/color-krasnoe/sugar_type-sukhoe/',
        title: 'Красное сухое',
    },
    {
        href: '/catalog/vino/filter/main-from-1000-to-2000/',
        title: 'Вино до 2 000 ₽',
    },
    {
        href: '/catalog/vino/filter/main-from-2000-to-3000/',
        title: 'Вино до 3 000 ₽',
    },
    {
        href: '/catalog/vino/filter/color-beloe/sugar_type-sukhoe/',
        title: 'Белое сухое',
    },
    {
        href: '/catalog/vino/filter/country-frantsiya/',
        title: 'Французское вино',
    },
    {
        href: '/catalog/vino/filter/country-italiya/',
        title: 'Итальянское вино',
    },
    {
        href: '/catalog/vino/filter/region-bordo/',
        title: 'Бордо',
    },
    {
        href: '/catalog/vino/filter/region-burgundiya/',
        title: 'Бургундия',
    },
    {
        href: '/catalog/vino/filter/appellason-chianti_classico_docg-or-chianti_colli_senesi_docg-or-chianti_docg/',
        title: 'Кьянти',
    },
    {
        href: '/catalog/vino/filter/appellason-chablis_1_er_cru_aoc-or-chablis_aoc-or-chablis_grand_cru_aoc-or-petit_chablis_aoc/',
        title: 'Шабли',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-prosecco_doc-or-prosecco_valdobbiadene_superiore_docg/',
        title: 'Просекко',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/appellason-cava_do/',
        title: 'Кава',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/country-rossiya/',
        title: 'Русское игристое',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-lanson-or-louis_roederer/',
        title: 'Популярная Шампань',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-to-1000/',
        title: 'Игристое до 1 000 ₽',
    },
    {
        href: '/catalog/ksn/viski/filter/product_type-odnosolodovyy/',
        title: 'Односолодовый виски',
    },
    {
        href: '/catalog/ksn/viski/filter/product_type-kupazhirovannyy/',
        title: 'Купажированный виски',
    },
    {
        href: '/catalog/ksn/viski/filter/product_type-burbon/',
        title: 'Бурбон',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-1000-to-3000/',
        title: 'Игристое до 3 000 ₽',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/main-from-3000-to-5000/',
        title: 'Игристое до 5 000 ₽',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/present_pack-1/',
        title: 'Игристое в подарок',
    },
    {
        href: '/catalog/shampanskoe_i_igristoe_vino/filter/manufacturer-felix_solis-or-oddbird/',
        title: 'Безалкогольное игристое',
    },
    {
        href: '/catalog/vino/filter/manufacturer-oddbird/',
        title: 'Безалкогольное вино',
    },
    {
        href: '/catalog/vino/filter/manufacturer-graham_s-or-quinta_do_noval-or-warre_s/',
        title: 'Портвейн',
    },
    {
        href: '/catalog/vino/filter/manufacturer-valdespino/',
        title: 'Херес',
    },
    {
        href: '/catalog/ksn/konyak/filter/present_pack-1/',
        title: 'Коньяк в подарок',
    },
    {
        href: '/catalog/ksn/filter/manufacturer-onegin/',
        title: 'Водка Онегин',
    },
    {
        href: '/catalog/ksn/filter/manufacturer-tsar_tigran/',
        title: 'Армянский бренди',
    },
    {
        href: '/catalog/ksn/filter/drink_type-viski/',
        title: 'Виски',
    },
    {
        href: '/catalog/vino/filter/color-krasnoe/country-avstraliya/grape-shiraz/?sort=price_up',
        title: 'Австралийский шираз',
    },
    {
        href: '/catalog/vino/filter/country-chili/grape-karmener/?sort=price_up',
        title: 'Чилийский карменер',
    },
    {
        href: '/catalog/vino/filter/country-argentina-or-avstraliya-or-chili-or-novaya_zelandiya-or-soedinennye_shtaty_ameriki-or-yuzhnaya_afrika/?sort=price_up',
        title: 'Вина Нового Света',
    },
    {
        href: '/catalog/vino/filter/country-novaya_zelandiya/grape-sovinon_blan/',
        title: 'Новозеландский совиньон',
    },
];
